import { render, staticRenderFns } from "./RightChart3.vue?vue&type=template&id=5ca63587&scoped=true&"
import script from "./RightChart3.vue?vue&type=script&lang=js&"
export * from "./RightChart3.vue?vue&type=script&lang=js&"
import style0 from "./RightChart3.vue?vue&type=style&index=0&id=5ca63587&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca63587",
  null
  
)

export default component.exports